import { connect } from 'react-redux'
import { get } from 'lodash'
import Footer from './Footer'
import showAddToHomeModal from 'features/AddToHome/AddToHomeModal'

const stateToProps = ({ cms }) => ({
  links: get(cms, 'footer[0].fields.links', []),
})

const dispatchToProps = {
  showAddToHomeModal,
}

export default connect(stateToProps, dispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.container.js